import { inject, watch } from 'vue';

import { useCallback } from '@libs/use';

import { WebEngageSymbol } from '@/plugins/webengage';

export default function useWebEngage() {
  const onReady = useCallback();
  const webEngage = inject<any>(WebEngageSymbol);

  watch([webEngage.isReady, onReady.callback], ([isReady, callback]) => {
    if (isReady && callback) {
      onReady.trigger();
    }
  });

  return {
    webEngage,
    onWebEngageReady: onReady.on,
  };
}
